import React from 'react';
import { useParams } from 'react-router-dom';
import ContactView from './ContactView';

const ContactViewForReading: React.FC = () => {
  const { contactId } = useParams<{ contactId: string }>();

  return <ContactView initialMode="view" contactId={contactId} />;
};

export default ContactViewForReading;
